import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF,faInstagram,faYoutube } from '@fortawesome/free-brands-svg-icons'

import { postService } from '../_services/post.service';

export class SocialMedia extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            settings: {
                facebook: '',
                twitter: '',
                instagram:'',
                youtube:''
            }
        };
    }
    
    componentDidMount() {
        //settingsService.getAll().then(settings => this.setState({ settings }));
        postService.getBySlug("social-media").then(
            social => {
                this.setState({
                    settings:{
                        facebook: social[0].acf.facebook,
                        instagram: social[0].acf.instagram,
                        youtube: social[0].acf.youtube
                    }
                })
            }
          )
    }

    render() {
        const { settings } = this.state;

        return (
            <>
                <div className="social-icons-bar pt-4 pb-4">
                    <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-6 col-md-4">
                            <ul className="nav nav-fill">
                                <li className="nav-item">
                                    <a href={ settings.facebook || process.env.REACT_APP_LINK_FACEBOOK } className="nav-link rounded-circle">
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </a>
                                </li>

                                {/* <li className="nav-item">
                                    <a href={ settings.twitter || process.env.REACT_APP_LINK_TWITTER } className="nav-link rounded-circle">
                                         <FontAwesomeIcon icon={faTwitter} />
                                    </a>
                                </li> */}

                                <li className="nav-item">
                                    <a href={ settings.instagram || process.env.REACT_APP_LINK_INSTAGRAM } className="nav-link rounded-circle">
                                         <FontAwesomeIcon icon={faInstagram} />
                                     </a>
                                </li>

                                <li className="nav-item">
                                    <a href={ settings.youtube || process.env.REACT_APP_LINK_YOUTUBE } className="nav-link rounded-circle">
                                    <FontAwesomeIcon icon={faYoutube} />
                                    </a>
                                </li>

                                </ul>
                            </div>
                        </div>					
                    </div>
                </div>
            </>
        )
    }
}

export default SocialMedia
